"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.tab.posts': 'Publicaciones',
    'socialMediaPlan.tab.calendar': 'Calendario',
    'socialMediaPlan.tab.history': 'Historial',
};
